// =====================================
//  新增／更改常用地址 modal
//
//  @author: Gray
//  @time 2016 / 09 / 02
// =====================================

window.InifECMobileApp.directive('editAddress', ['$rootScope', '$ngModal', '$timeout', 'UserService',
    function ($rootScope, $ngModal, $timeout, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // 新增／修改
            // --------------------------------
            var submit = function() {

                if($scope.isLoading) {
                    return;
                }

                checkFormValue();

                if($scope.isParamsEmpty || $scope.isParamsError) {
                    return;
                }

                var _submit = $scope.isEdit ? UserService.updateFavoriteAddress : UserService.addFavoriteAddress,
                    name = $scope.form.name,
                    phone = $scope.form.phone,
                    mobilephone = $scope.form.mobilephone,
                    postal = $scope.form.postal,
                    address = $scope.form.address,
                    remark = $scope.form.remark,
                    phoneExtension = $scope.form.phoneExtension,
                    index = $scope.index;

                var titles = {
                    loadingtitle: $scope.isEdit ? '正在更新常用地址' : '正在新增常用地址',
                    successtitle: $scope.isEdit ? '成功更新常用地址' : '成功新增常用地址',
                }

                $scope.isLoading = true;

                $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                    title: '正在新增常用地址',
                });

                _submit(name, phone, mobilephone, postal, address, remark, phoneExtension, index).then(function(result) {

                    if(result) {
                        $scope.isLoading = false;
                        ($scope.callback) && $scope.callback(result);

                        $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                            title: '成功新增常用地址',
                        });

                        closeModal();
                    } else {
                        $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                            title: '系統發生錯誤',
                        });

                    }

                }, function(error) {

                    $scope.isError = true;
                    $scope.isLoading = false;

                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                })
            }

            // --------------------------------
            // [private] 檢查表單內容
            // --------------------------------
            var checkFormValue = function() {

                $scope.isError = false;
                $scope.isParamsEmpty = false;
                $scope.isParamsError = false;

                $scope.isNameEmpty = false;
                $scope.isAddressEmpty = false;
                $scope.isPhoneEmpty = false;
                $scope.isPostalEmpty = false;
                $scope.isPostalError = false;
                $scope.isPhoneError = false;
                $scope.isMobilePhoneError = false;

                if(!$scope.form.name || $scope.form.name == '') {
                    $scope.isNameEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if(!$scope.form.address || $scope.form.address == '' || !$scope.form.newAddress) {
                    $scope.isAddressEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if(!$scope.form.postal || $scope.form.postal == '') {
                    $scope.isPostalEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if($scope.form.postal && isNaN($scope.form.postal)) {
                    $scope.isPostalError = true;
                    $scope.isParamsError = true;
                }

                if((!$scope.form.phone || $scope.form.phone == '') && (!$scope.form.mobilephone || $scope.form.mobilephone == '')) {
                    $scope.isPhoneEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if($scope.form.phone && !isPhone($scope.form.phone)) {
                    $scope.isPhoneError = true;
                    $scope.isParamsError = true;
                }

                if($scope.form.mobilephone && !isPhone($scope.form.mobilephone)) {
                    $scope.isMobilePhoneError = true;
                    $scope.isParamsError = true;
                }
            }

            // --------------------------------
            // [private] 重設所有表單內容
            // --------------------------------
            var resetFormValue = function() {
                
                $scope.form.name = '';
                $scope.form.postal = '';
                $scope.form.address = '';
                $scope.form.mobilephone = '';
                $scope.form.phone = '';
                $scope.form.remark = '';
                $scope.form.phoneExtension = '';
            }

            // --------------------------------
            // [private] 重設所有判斷
            // --------------------------------
            var resetState = function() {

                $scope.isError = false;
                $scope.isParamsEmpty = false;
                $scope.isParamsError = false;

                $scope.isNameEmpty = false;
                $scope.isAddressEmpty = false;
                $scope.isPhoneEmpty = false;
                $scope.isPostalEmpty = false;
                $scope.isPostalError = false;
                $scope.isPhoneError = false;
                $scope.isMobilePhoneError = false;
            }

            // --------------------------------
            // [private] 設定表單內容
            // --------------------------------
            var setFormValue = function(address) {

                $scope.form.name = address.name ? address.name : '';
                $scope.form.postal = address.postal ? address.postal : '';
                $scope.form.twZipCode = address.twZipCode ? address.twZipCode : '';
                $scope.form.address = address.address ? address.address : '';
                $scope.form.mobilephone = address.mobilephone ? address.mobilephone : '';
                $scope.form.phone = address.phone ? address.phone : '';
                $scope.form.remark = address.remark ? address.remark : '';
                $scope.form.phoneExtension = address.phoneExtension ? address.phoneExtension : '';
            }

            // -------------------------------
            // 離開新增／更改常用地址
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            //  開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('edit-address-modal');
            }

            // -------------------------------
            //  關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('edit-address-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_NEW_ADDRESS_MODAL', function(event, data) {
                
                if(data) {
                    $scope.isLoading = false;
                    $scope.isEdit = false;
                    $scope.callback = data.callback;

                    resetFormValue();
                    resetState();
                    openModal();    
                }
            });

            $scope.$on('OPEN_EDIT_ADDRESS_MODAL', function(event, data) {
                
                if(data) {
                    $scope.isLoading = false;
                    $scope.isEdit = true;
                    $scope.callback = data.callback;
                    $scope.index = data.index;

                    setFormValue(data.address);
                    openModal();    
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.form = {
                name: '',
                postal: '',
                address: '',
                mobilephone: '',
                phone: '',
                remark: '',
                phoneExtension: '',
                newAddress: '',
            };

            $scope.index = undefined;

            $scope.isEdit = false;
            $scope.isLoading = false;
            $scope.isError = false;
            $scope.isNameEmpty = false;
            $scope.isAddressEmpty = false;
            $scope.isPhoneEmpty = false;
            $scope.isParamsEmpty = false;
            $scope.isParamsError = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isPhoneError = false;
            $scope.isMobilePhoneError = false;
            
            /*==========================
                Methods
            ==========================*/
            $scope.submit = submit; // 新增 / 儲存
            $scope.cancel = cancel; // 離開新增／更改常用地址

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/edit_address.html";
        _dir.controller = controller;

        return _dir;
    }]
);